import { useQuery } from '@/hooks/apollo/useQuery';
import { GET_USER } from '@/pageQueries/user.query';
import { Get_UserQuery, Get_UserQueryVariables } from '@/types/apollo';
import { redirectToLogin } from '@/utils/redirect';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { RETRY_URL_FIELD_NAME } from './error/index.page';
import LoadingSpinner from '@/components/Common/Loading/Spinner';
import classNames from 'classnames/bind';
import styles from './index.page.module.scss';

const cx = classNames.bind(styles);

const allowedHosts = ['www.tripplat.com', 'test.tripplat.com', 'st.tripplat.com'];

const Login = () => {
  const { data, loading, error } = useQuery<Get_UserQuery, Get_UserQueryVariables>(GET_USER);
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (loading) {
      return;
    }

    const url = searchParams.get('returnUrl');
    const urlObj = url ? new URL(url, window.location.origin) : null;
    const host = urlObj?.host;

    if (!url || !host || !allowedHosts.includes(host)) {
      router.push(`/login/error`);
      return;
    }

    const userId = data?.user?.id;

    if (error) {
      router.push(`/login/error?${RETRY_URL_FIELD_NAME}=${window.location.href}`);
      return;
    }

    if (!userId) {
      redirectToLogin();
      return;
    }

    urlObj.searchParams.set('userId', userId);
    window.location.replace(urlObj.toString());
  }, [data?.user, error, loading, router, searchParams]);

  return (
    <div className={cx('redirecting')}>
      <div className={cx('spinner')}>
        <LoadingSpinner />
      </div>
      <strong>예약 화면으로 이동하고 있습니다</strong>
      <span>잠시만 기다려주세요</span>
    </div>
  );
};

export default Login;
